import { Middleware, Context } from '@nuxt/types';
import { saveQueue } from '../lib/utilities/saveQueue';
import { SaveMessageState } from '../lib/enums/saveMessage';

const initialise: Middleware = (context: Context) => {
  const store = context.store;

  saveQueue.pending = () => {
    store.commit(
      'components/contact-upload-navigation/setSaveMessageState',
      {
        saveMessageState: SaveMessageState.Pending
      },
      { root: true }
    );
  };
  saveQueue.complete = () => {
    store.commit(
      'components/contact-upload-navigation/setSaveMessageState',
      {
        saveMessageState: SaveMessageState.Saved
      },
      { root: true }
    );
  };

  if (context.params.id && !store.getters['contact-upload/id']) {
    store.commit('contact-upload/setId', context.params.id, { root: true });
    return store.dispatch('contact-upload/loadContactUpload');
  }
};

export default initialise;
